module.exports = __webpack_public_path__ + "Lato-ThinItalic.2e89a614a99ac1324dac.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-ThinItalic.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-ThinItalic.eot
// module chunks = styles